import React from 'react';

import Proptypes from 'prop-types';
import Input from '@tds/core-input';
import Box from '@tds/core-box';

import { useLocalizedStringsContext } from '../../../../../../../context/LocalizedStringsContext';

const ContractRecipient = ({ contractRecipient, setContractRecipient }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    ORDERS: {
      emailDetail: {
        contractAddress,
        contractAddressDetail,
        CCEmailAddress,
        CCEmailAddressDetail
      }
    }
  } = localizedStrings;

  return (
    <Box between={3}>
      <Input
        label={contractAddress}
        hintPosition="below"
        hint={contractAddressDetail}
        value={contractRecipient.to}
        onChange={e =>
          setContractRecipient({ ...contractRecipient, to: e.target.value })
        }
      />
      <Input
        label={CCEmailAddress}
        hintPosition="below"
        hint={CCEmailAddressDetail}
        value={contractRecipient.cc}
        onChange={e =>
          setContractRecipient({ ...contractRecipient, cc: e.target.value })
        }
      />
    </Box>
  );
};

ContractRecipient.propTypes = {
  contractRecipient: Proptypes.objectOf(
    Proptypes.shape({ to: Proptypes.string, cc: Proptypes.string })
  ).isRequired,
  setContractRecipient: Proptypes.func.isRequired
};

export default ContractRecipient;
